export const ENV_UY = {
  API: {
    TRAVEL: 'https://services.rappi.com.uy/ms-travel/',
    PROFILE: 'https://services.rappi.com.uy/ms-profile/',
    RULES: 'https://services.rappi.com.uy/ms-rule-engine/',
    LOGIN: 'https://services.rappi.com.uy/api/rocket/login/password/application_user',
    USER: 'https://services.rappi.com.uy/ms/application-user/auth',
    COUNTRIES: 'https://restcountries.com/v2/',
    LOGIN_EXCHANGE: 'https://v2.dev.rappi.com/api/rocket/exchange/authorization_code',
    RAPPI_SERVICES: 'https://services.rappi.com.uy/api/',
    RAPPI_SERVICES_CITIES: 'https://services.grability.rappi.com/api/travel/search/',
    RAPPI_SERVICES_TRAVEL_CITY_SEARCH: 'https://services.grability.rappi.com/api/travel-city-search/',
    NETACTICA_CITIES: 'https://reservas.netactica.com/corp-ms-travel/data/AutoComplete/Cities',
    NETACTICA_COUNTRIES: 'https://reservas.netactica.com/corp-ms-travel/data/AutoComplete/Countries',
    NETACTICA_PROVINCES: 'https://reservas.netactica.com/corp-ms-travel/Travels/GetProvinces',
    RAPPI_SERVICES_TRAVEL_HOTEL_SEARCH: '',
    RAPPI_SERVICES_TRAVEL_HOTEL_SEARCH_OLD:
      'https://services.grability.rappi.com/NetCoreapi/AutocompleteDestinationStaticContent',
    RAPPI_SERVICES_TRAVEL_HOTEL_CONTENT: 'https://services.grability.rappi.com/travel-hotel-content/hotel-location/',
    RAPPI_IMAGES_CDN: 'https://images.rappi.com/',
    REACT_APP_SEARCH_MAX_RESULT_PER_PAGE: 10,
  },
  API_KEYS: {
    GOOGLE_MAPS_API_KEY: 'AIzaSyACK5kL1Mx67-XzZPtERXXxDhIkhJBAOoE',
    KUSTOMER_FORM_ID: '5f524de4f0a0d900963139d2',
    AMPLITUDE_KEY: '101be7b7fdda892d329579012e8dd69a',
  },
  RAPPI_OAUTH: {
    REDIRECT_URL_FROM_LOGIN: '',
    REDIRECT_URL_FROM_REGISTRATION: '',
    REDIRECT_URL_FROM_INVITE: '',
    LOGIN_CLIENTID: '',
    LOGIN_URL: '',
    SIGNUP_URL: '',
  },
  LANDING_PAGE:
    'https://preprod.netactica.com/ns-login/es/netviajes?redirectUrl=https://preprod.netactica.com/corporate/auth&continue=https://preprod.netactica.com/corporate/booking',
  SENTRY_DSN: 'https://fe011ed6ec14461595fd1716c48e310d@o484725.ingest.sentry.io/5538357',
  SEARCH_MAX_RESULT_PER_PAGE: 10,
  COUNTRY_CODE: 598,
  RAPPI_BRANCH_CODE: 'CORP',
};
